import { useEffect, useState, useRef } from 'react';
import './InfoPageFrame.css';
import { ProfileCard, BasicCard, DetailedCard } from './ProfileCard';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkSquareAlt } from '@fortawesome/free-solid-svg-icons';
import { faFacebookSquare, faInstagramSquare, faLinkedin, faTwitterSquare, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons';
import { json } from 'd3-fetch';
import { peoplePromise } from './index.js';
import { ProgressPanel } from './ProgressPanel';

const presence = {
    "web": { title: "Web", icon: faExternalLinkSquareAlt },
    "web2": { title: "Web", icon: faExternalLinkSquareAlt },
    "twitter": { title: "Twitter", icon: faTwitterSquare },
    "facebook": { title: "Facebook", icon: faFacebookSquare },
    "facebook2": { title: "Facebook", icon: faFacebookSquare },
    "linkedin": { title: "LinkedIn", icon: faLinkedin },
    "youtube": { title: "YouTube", icon: faYoutubeSquare },
    "instagram": { title: "Instagram", icon: faInstagramSquare }
}

export default function InfoPageFrame(props) {

    const [ fetching, setFetching] = useState(true);
    const [ profileCard, setProfileCard] = useState({visible: false, left: 0, right: 0, person: null});
    const oldPage = useRef("");

    useEffect(()=> {
        if (props.file && props.file !== oldPage.current) {
            setFetching(true);
            Promise.all([peoplePromise(), json(props.file)]).then(([ , info]) => {
                oldPage.current = props.file;
                setFetching(false);
                if (props.onPageDataLoaded)
                    props.onPageDataLoaded(info);
            });
        }
    }, [props]);

    if (fetching || !props.name)
        return <ProgressPanel id="research-group-info" lang={props.lang} />;

    return (
        <div id="infopage-container">
            <div className="upper">
                {props.logo && props.logo.length > 0 && <img src={props.logo[0]==="." ? props.logo : `./data/${props.logo}`} alt="logo"/>}
                <h1>{props.name[props.lang]}</h1>
                <h2>{props.keywords.join(" • ")}</h2>
            </div>
            <div className="line"></div>
            <div className="leader-container">
                {props.leaders.map((d, ix) => <DetailedCard key={ix} person={d} lang={props.lang} onClick={(p, l, r) => setProfileCard({person: p, left: l, right: r, visible: true})}/>)}
                <div className="links">
                    {props.presence && Object.entries(props.presence).map((d, ix) => 
                        <a key={ix} href={d[1]} title={presence[d[0]].title} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={presence[d[0]].icon} size="lg"/></a>
                    )}
                </div>
            </div>
            {props.staff && <>
                <div className="section-title">
                    {props.lang === "hu" ? "A kutatócsoport tagjai:" : "Members of the research group:"}
                </div>            
                <div className="staff-container">
                    {props.staff.filter(d => d.position.toLowerCase() !== "doktorandusz").map((d, ix) => <BasicCard key={ix} person={d} lang={props.lang} onClick={(p, l, r) => setProfileCard({person: p, left: l, right: r, visible: true})}/>)}
                </div>
            </>}
            <div className="description-container">
                {props.children}
            </div>
            {profileCard.visible && profileCard.person && <>
                <div className="background" onClick={() => setProfileCard({visible: false})}/>
                <ProfileCard lang={props.lang} person={profileCard.person} left={profileCard.left} right={profileCard.right} onClick={() => setProfileCard({visible: false, person: null})}/>
            </> }
        </div>        
    );
}
